import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ComponentPreviewCardProps {
  label: string;
  children: ReactNode;
  className?: string;
}

export function ComponentPreviewCard({ label, children, className }: ComponentPreviewCardProps) {
  return (
    <div className={cn('flex flex-col gap-3 p-4 border rounded-lg bg-card/30', className)}>
      <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mb-1">
        {label}
      </span>
      <div className="flex flex-wrap items-center gap-4">
        {children}
      </div>
    </div>
  );
}
